import axios from "axios";
import i18n from "../i18n";

const axiosInstance = axios.create({
    headers:{
        "Content-Type":"application/json"
    },
    withCredentials:false
})

axiosInstance.interceptors.request.use(request=>{
    const language = i18n.language ;
    request.headers['Accept-language'] = language
    return request;
},error=>{
    return Promise.reject(error)
})

export default axiosInstance;